/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
export var InvitationStatus;
(function (InvitationStatus) {
    InvitationStatus["CREATED"] = "created";
    InvitationStatus["DELIVERED"] = "delivered";
    InvitationStatus["PENDING_AUTHORIZATION"] = "pendingAuthorization";
    InvitationStatus["DENIED"] = "denied";
    InvitationStatus["DELETED"] = "deleted";
    InvitationStatus["EXPIRED"] = "expired";
    InvitationStatus["AUTO_AUTHORIZED"] = "autoAuthorized";
    InvitationStatus["MANUAL_AUTHORIZED"] = "manualAuthorized";
    InvitationStatus["OPEN"] = "OPEN";
    InvitationStatus["ACCEPTED"] = "ACCEPTED";
    InvitationStatus["DIFFERENT_EMAIL_PENDING_CONFIRM"] = "DIFFERENT_EMAIL_PENDING_CONFIRM";
    InvitationStatus["CANCELLED"] = "CANCELLED";
})(InvitationStatus || (InvitationStatus = {}));
